import type { Row } from "../byMonthTypes";

// Products with no stored quantity for the anchor month (the first plan month
// that is today or later). Mirrors Plan::ByMonth::Completion — the server
// re-checks on Submit; computed client-side so the label moves as cells are typed.
export function monthlyMissing(rows: Row[], anchorMonth: string | null): string[] {
  if (!anchorMonth) return [];
  return rows
    .filter((r) => !r.months.some((m) => m.period_date === anchorMonth && m.filled))
    .map((r) => r.product_name);
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function monthLabel(iso: string): string {
  const [y, m] = iso.split("-");
  return `${MONTHS[parseInt(m, 10) - 1]} ${y}`;
}

// The widget's "Missing: …" phrase. Mirrors the blockers Plan::ByMonth::Completion
// returns, in the same order: no products placed, then a plan that has ended,
// then the products with no quantity for the anchor month.
export function missingSummary(rows: Row[], anchorMonth: string | null): string[] {
  if (rows.length === 0) return ["products on Products & Pricings"];
  if (!anchorMonth) return ["a plan month that has not ended"];

  const names = monthlyMissing(rows, anchorMonth);
  if (names.length === 0) return [];
  return [`a quantity for ${monthLabel(anchorMonth)} on ${names.length} product${names.length > 1 ? "s" : ""}`];
}
